









import Vue from 'vue';
import { OpenUpdateCoverageTierScreen } from '@/mixins/get-content-mixins';
import SettingWrapper from '../setting-wrapper.component.vue';
import { ExtendMixins } from '@/services';
import { CTA } from '@/@types/member';

export default ExtendMixins(
  OpenUpdateCoverageTierScreen,
).extend({
  name: 'ManageCoverage',
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    coverageTier: {
      type: String,
      required: true,
    },
    isSuppressCoverageEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    changeCoverage(): void {
      this.openUpdateCoverageTierScreen({ accountId: this.accountId });
    },
  },
  computed: {
    coverageCTA(): CTA {
      return !this.isSuppressCoverageEdit
      ? { text: this.$options.filters.t(['account-settings_action_edit-plan-coverage', 'global_edit']), action: this.changeCoverage }
      : { text: null, action: null};
    },
  },
  components: {
    SettingWrapper,
  },
});
